// Lightweight toast utility shared across pages
// Usage: import { toast } from "../lib/toast"; toast("Saved", "success")
// duration に 0 / null を渡すと自動消滅せず、閉じる(×)ボタンを出す(エラー表示用)
const CONTAINER_ID = 'toast-right-container'
// 自動消滅しないトーストは積み上がると画面を覆うため、同時表示は最大3件に制限する
const MAX_STICKY = 3

function stickyToasts(container) {
  return Array.from(container.querySelectorAll('[data-toast-sticky="true"]'))
}

export function toast(message, kind = 'info', { duration = 2500 } = {}) {
  let container = document.getElementById(CONTAINER_ID)
  if (!container) {
    container = document.createElement('div')
    container.id = CONTAINER_ID
    container.className = 'fixed top-20 right-4 z-[60] space-y-2'
    document.body.appendChild(container)
  }

  const el = document.createElement('div')
  const base = 'alert shadow-lg translate-x-80 opacity-0 transition-all duration-300'
  const tone = kind === 'success' ? 'alert-success' : kind === 'error' ? 'alert-error' : 'alert-info'
  el.className = `${base} ${tone}`
  // message は textContent で入れる(HTML として解釈させない)
  const text = document.createElement('span')
  text.textContent = message
  el.appendChild(text)
  container.appendChild(el)

  requestAnimationFrame(() => {
    el.classList.remove('translate-x-80', 'opacity-0')
    el.classList.add('translate-x-0', 'opacity-100')
  })

  const dismiss = () => {
    el.classList.remove('translate-x-0', 'opacity-100')
    el.classList.add('translate-x-80', 'opacity-0')
    setTimeout(() => el.remove(), 300)
  }

  if (duration) {
    setTimeout(dismiss, duration)
    return el
  }

  el.dataset.toastSticky = 'true'
  // 上限を超えた分は古いものから即座に取り除く(自分自身は末尾なので残る)
  const overflow = stickyToasts(container).length - MAX_STICKY
  for (let i = 0; i < overflow; i++) {
    stickyToasts(container)[0].remove()
  }

  const closeButton = document.createElement('button')
  closeButton.type = 'button'
  closeButton.className = 'btn btn-ghost btn-xs ml-auto'
  closeButton.setAttribute('aria-label', '閉じる')
  closeButton.textContent = '✕'
  closeButton.addEventListener('click', dismiss)
  el.appendChild(closeButton)
  return el
}

// Turbo のページキャッシュに残ったトーストが「戻る」で復元されないよう、キャッシュ前に空にする
document.addEventListener('turbo:before-cache', () => {
  const container = document.getElementById(CONTAINER_ID)
  if (container) container.replaceChildren()
})
